import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { environment } from '@env/environment';

// TEMPORARY: hardcoded because there's no env-var delivery mechanism for the
// FE build yet. Same key/hash as the BE
// (packages/shared/observability/health.js in hropalplus-backend) - keep
// both in sync if this ever changes. NOTE: unlike the BE, this hash ships
// inside the public JS bundle - anyone can read it via devtools. That's
// still fine for a HASH (not practically reversible to the key), just never
// put the plaintext key here.
// Hash of "Developer@123".
const SERVER_INFO_KEY_HASH = 'e1a7b8ad45f95c9d0f401381236891d369ca80790393e307805e1dd700f8ecca';
const SERVER_INFO_KEY_QUERY_PARAM = 'key';

async function sha256Hex(value: string): Promise<string> {
  const bytes = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

// Deploy-visibility route (/server-info) is open outside production; in
// production it requires ?key=<shared secret> matching SERVER_INFO_KEY_HASH -
// same scheme as the BE's own /server-info (see health.js's isAuthorized).
export const nonProdGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  if (!environment.production) {
    return true;
  }

  // inject() must run synchronously, before any `await`.
  const router = inject(Router);

  const provided = route.queryParamMap.get(SERVER_INFO_KEY_QUERY_PARAM);
  if (provided && (await sha256Hex(provided)) === SERVER_INFO_KEY_HASH) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
